export default "__VITE_ASSET__BiT1e9mJ__"